import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  appointmentStartDateTime: '',
  appointmentEndDateTime: '',
  appointmentAppliedFees: []
};
const followUpSlice = createSlice({
  name: 'followUpSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setFollowUpData(state, action) {
      state.appointmentStartDateTime = action.payload?.appointmentStartDateTime;
      state.appointmentEndDateTime = action.payload?.appointmentEndDateTime;
      state.appointmentAppliedFees = action.payload?.services;
    }
    //set selected service by doctor (inside createAndViewServices)
  }
});
export const { setFollowUpData } = followUpSlice.actions;
export default followUpSlice.reducer;
